<template>
  <page>
    <template slot="content">
      <template>
        <list-group :title="'消耗品について'">
          <list-item :spanText="'Q. '" :text="'ベルトを交換したい'" :urlName="'Help35'"></list-item>
        </list-group>
      </template>
    </template>
  </page>
</template>

<script>
  import ListGroup from '@/components/ListGroup'
  import ListItem from '@/components/ListItem'
  import Tab from '@/components/Tab'
  import TabBtn from '@/components/TabBtn'
  import TabContent from '@/components/TabContent'
  import Page from '@/components/Page'

  export default {
    name: 'HelpPage',
    components: {
      ListGroup,
      ListItem,
      Tab,
      TabBtn,
      TabContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/HelpCategory32.vue